export default __webpack_public_path__ + "static/media/thumbnail3.c85fecc3.jpg";